<script setup lang="ts">
definePageMeta({
  name: 'product-catalogue',
  layout: 'nettbutikk',
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: {
    label: 'Våre abonnement',
  },
})

useHead({
  bodyAttrs: {
    class: 'bg-white',
  },
})

const { data, suspense } = useProductCatalogue()

await suspense()

const description = computed(() => getTextContent(data.value?.components?.description))

useSeoMeta({
  ogTitle: data.value?.components?.title,
  description,
  ogDescription: description,
})
</script>

<template>
  <section>
    <NettbutikkProductCatalogueHeader :data="data" />
    <NettbutikkProductCatalogueList :data="data" />
  </section>
</template>
